<div
    class="accordion-item"
    (mousedown)="onMouseDown()"
    (mouseup)="onMouseUp()"
    (mouseleave)="onMouseUp()"
    [ngClass]="{ showDragIcon: isHeld }"
>
    <div
        class="accordion-header"
        (click)="onToggle()"
        role="button"
        [attr.aria-expanded]="expanded"
        [class.disabled]="disabled"
    >
        <ng-content select="[accordion-header]"></ng-content>
    </div>
    <div class="accordion-body" [@expandCollapse]="expanded ? 'expanded' : 'collapsed'" role="region">
        <ng-content select="[accordion-body]"></ng-content>
    </div>
    <div class="accordion-body-closed" *ngIf="!expanded">
        <ng-content select="[accordion-body-closed]"></ng-content>
    </div>
</div>
